export default __webpack_public_path__ + "static/media/install.3d0cfb30.png";